import { Outlet, createRootRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import {
  type LanguageCode,
  LanguageProvider,
  detectBrowserLanguage,
  detectLanguageFromQuery,
} from '~/lib/i18n';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const language = useMemo<LanguageCode>(() => {
    if (typeof window === 'undefined') return 'vi';
    return detectLanguageFromQuery(window.location.search) ?? detectBrowserLanguage();
  }, []);

  return (
    <LanguageProvider language={language}>
      <div className="app-shell">
        <Outlet />
      </div>
    </LanguageProvider>
  );
}
